import { SearchEffects } from "app/store/effects/search.effects";

export const effectsAArr = [SearchEffects];
